import { render, staticRenderFns } from "./ToolBarAuth.vue?vue&type=template&id=346b643e&scoped=true&"
import script from "./ToolBarAuth.vue?vue&type=script&lang=js&"
export * from "./ToolBarAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b643e",
  null
  
)

export default component.exports